<ul class="wallNav__list flex">
  <li class="wallNav__item">
    <a class="wallNav__link"
       routerLink="/entity/list"
       queryParamsHandling="merge"
       matTooltip="List View"
       [queryParams]="queryKeysToClearOnListClick"
       routerLinkActive="wallNav__link--active">
      <span class="screen-reader">List View</span>
      <i class="wallNav__icon fal fa-fw fa-list"></i>
    </a>
  </li>
  <li class="wallNav__item">
    <a class="wallNav__link"
       matTooltip="Chart View"
       routerLink="/entity/chart"
       queryParamsHandling="merge"
       [queryParams]="queryKeysToClearOnChartClick"
       routerLinkActive="wallNav__link--active">
      <span class="screen-reader">Chart View</span>
      <i class="wallNav__icon fal fa-fw fa-bars-progress"></i>
    </a>
  </li>
  <li class="wallNav__item">
    <a class="wallNav__link"
       routerLink="/entity/visualization"
       queryParamsHandling="merge"
       matTooltip="Trend View"
       [queryParams]="queryKeysToClearOnVisualizationClick"
       routerLinkActive="wallNav__link--active">
      <span class="screen-reader">Trend View</span>
      <i class="wallNav__icon fal fa-fw fa-chart-column"></i>
    </a>
  </li>
  <li class="wallNav__item">
    <a class="wallNav__link"
       routerLink="/entity/map-view"
       matTooltip="Map View"
       queryParamsHandling="merge"
       [queryParams]="queryKeysToClearOnMapClick"
       routerLinkActive="wallNav__link--active">
      <span class="screen-reader">Map View</span>
      <i class="wallNav__icon fal fa-fw fa-map"></i>
    </a>
  </li>
</ul>
